import { RemoteAccessProfile } from '@mss/mss-component-library';
import Fetch from 'jsx/common/util/_fetch';

const create = async (profile: RemoteAccessProfile) => {
  return Fetch.post(`/api/remote-profile/`, {
    body: JSON.stringify(profile),
  });
};

export default create;
